// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ExternalImportFailedItem,
  ExternalImportFailedItemFromJSON,
  ExternalImportFailedItemToJSON,
  ExternalImportStatsCasesSkippedDuplicateDetails,
  ExternalImportStatsCasesSkippedDuplicateDetailsFromJSON,
  ExternalImportStatsCasesSkippedDuplicateDetailsToJSON,
} from "./";

/**
 * Running counts emitted by the import runner
 * @export
 * @interface ExternalImportStats
 */
export interface ExternalImportStats {
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  suitesCreated?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  casesCreated?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  casesSkippedDuplicate?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ExternalImportStats
   */
  casesSkippedDuplicateKeys?: Array<string>;
  /**
   *
   * @type {Array<ExternalImportStatsCasesSkippedDuplicateDetails>}
   * @memberof ExternalImportStats
   */
  casesSkippedDuplicateDetails?: Array<ExternalImportStatsCasesSkippedDuplicateDetails>;
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  casesSkippedPreviouslyImported?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  testSetsCreated?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  testPlansCreated?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  manualCount?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  cucumberCount?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportStats
   */
  genericCount?: number;
  /**
   *
   * @type {Array<ExternalImportFailedItem>}
   * @memberof ExternalImportStats
   */
  failed?: Array<ExternalImportFailedItem>;
}

export function ExternalImportStatsFromJSON(json: any): ExternalImportStats {
  return {
    suitesCreated: !exists(json, "suites_created")
      ? undefined
      : json["suites_created"],
    casesCreated: !exists(json, "cases_created")
      ? undefined
      : json["cases_created"],
    casesSkippedDuplicate: !exists(json, "cases_skipped_duplicate")
      ? undefined
      : json["cases_skipped_duplicate"],
    casesSkippedDuplicateKeys: !exists(json, "cases_skipped_duplicate_keys")
      ? undefined
      : json["cases_skipped_duplicate_keys"],
    casesSkippedDuplicateDetails: !exists(
      json,
      "cases_skipped_duplicate_details"
    )
      ? undefined
      : (json["cases_skipped_duplicate_details"] as Array<any>).map(
          ExternalImportStatsCasesSkippedDuplicateDetailsFromJSON
        ),
    casesSkippedPreviouslyImported: !exists(
      json,
      "cases_skipped_previously_imported"
    )
      ? undefined
      : json["cases_skipped_previously_imported"],
    testSetsCreated: !exists(json, "test_sets_created")
      ? undefined
      : json["test_sets_created"],
    testPlansCreated: !exists(json, "test_plans_created")
      ? undefined
      : json["test_plans_created"],
    manualCount: !exists(json, "manual_count")
      ? undefined
      : json["manual_count"],
    cucumberCount: !exists(json, "cucumber_count")
      ? undefined
      : json["cucumber_count"],
    genericCount: !exists(json, "generic_count")
      ? undefined
      : json["generic_count"],
    failed: !exists(json, "failed")
      ? undefined
      : (json["failed"] as Array<any>).map(ExternalImportFailedItemFromJSON),
  };
}

export function ExternalImportStatsToJSON(value?: ExternalImportStats): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    suites_created: value.suitesCreated,
    cases_created: value.casesCreated,
    cases_skipped_duplicate: value.casesSkippedDuplicate,
    cases_skipped_duplicate_keys: value.casesSkippedDuplicateKeys,
    cases_skipped_duplicate_details:
      value.casesSkippedDuplicateDetails === undefined
        ? undefined
        : (value.casesSkippedDuplicateDetails as Array<any>).map(
            ExternalImportStatsCasesSkippedDuplicateDetailsToJSON
          ),
    cases_skipped_previously_imported: value.casesSkippedPreviouslyImported,
    test_sets_created: value.testSetsCreated,
    test_plans_created: value.testPlansCreated,
    manual_count: value.manualCount,
    cucumber_count: value.cucumberCount,
    generic_count: value.genericCount,
    failed:
      value.failed === undefined
        ? undefined
        : (value.failed as Array<any>).map(ExternalImportFailedItemToJSON),
  };
}
